import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-29d60fe9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = { class: "item-name text-truncate" }
const _hoisted_4 = {
  key: 2,
  class: "items-bottom"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "items-limit"
}
const _hoisted_8 = { class: "items-count" }

import {computed, onMounted, Ref, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";
import config from "@/config.json";
import {Item} from "@/types/Item";
import {Guild} from "@/types/Guild";
import CreateItem from "@/components/items/CreateItem.vue";
import EditItem from "@/components/items/EditItem.vue";
import DeleteItem from "@/components/items/DeleteItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Items',
  setup(__props) {

const route = useRoute()
const store = useStore()
let guild = computed(() => (store.getters.guilds as Array<Guild>).find(g => g.id === route.params.id));
let loading = ref(false)
let name = ref();
let items: Ref<Array<Item>> = ref([]);

const limit = {
  standard: 15,
  boost: 30
}
let lim = guild.value?.settings?.boost ? limit.boost : limit.standard

function created(item: Item) {
  items.value.push(item)
}

function deleted(item: Item) {
  items.value.splice(items.value.findIndex(i => i.name === item.name), 1)
}

onMounted(async () => {
  loading.value = true;
  let response = await fetch(`${config.API}/private/guilds/${route.params.id}/items`, {
    headers: {
      Authorization: localStorage.getItem('token') as string
    }
  })
  if(response.ok) {
    items.value = await response.json();
    items.value = items.value.map(item => {item.newName = item.name; return item})
  }
  loading.value = false;
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(loading))
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            class: "loading",
            size: 40,
            width: 4,
            indeterminate: ""
          }))
        : _createCommentVNode("", true),
      (_unref(items).length && !_unref(loading))
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(items), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
                _createElementVNode("div", null, [
                  _createVNode(EditItem, {
                    item: item,
                    names: _unref(items).map(i => i.name),
                    class: "item-action"
                  }, null, 8, ["item", "names"]),
                  _createVNode(DeleteItem, {
                    item: item,
                    onDelete: deleted,
                    class: "item-action"
                  }, null, 8, ["item"])
                ])
              ]),
              _createVNode(_component_v_divider)
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (!_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", null, [
              (_unref(items).length < _unref(lim))
                ? (_openBlock(), _createBlock(CreateItem, {
                    key: 0,
                    names: _unref(items).map(i => i.name),
                    onCreate: created
                  }, null, 8, ["names"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_unref(guild).settings.boost)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('Items.subtitles.limit')), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_router_link, {
                            class: "donate-link",
                            to: "/donate"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("favorite")
                                ]),
                                _: 1
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('Items.subtitles.donate')), 1)
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('Items.subtitles.increaseLimit')) + " " + _toDisplayString(limit.boost), 1)
                        ]))
                  ]))
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(items).length) + "/" + _toDisplayString(_unref(lim)), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})